"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _upsellActions = require("../../store/upsell/upsellActions");
var _constants = require("../../utils/constants");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _upsellSelectors = require("../../store/upsell/upsellSelectors");
var _productCatalogSelectors = require("../../store/productCatalog/productCatalogSelectors");
var _lodash = _interopRequireDefault(require("lodash.groupby"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useUpsell = function useUpsell() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var upsellSettings = (0, _reactRedux.useSelector)(_widgetSelectors.selectUpsellSettings);
  var selectedUpsellProducts = (0, _reactRedux.useSelector)(_upsellSelectors.selectSelectedUpsellProducts);
  var offerings = (0, _reactRedux.useSelector)(_productCatalogSelectors.selectRelationshipOfferings);
  var connectivityPlan = (0, _reactRedux.useSelector)(_upsellSelectors.selectConnectivityPlan);
  var categoryStatus = {};
  upsellSettings.upsellTypes.forEach(function (type) {
    var _selectedUpsellProduc;
    categoryStatus[type.value] = ((_selectedUpsellProduc = selectedUpsellProducts[type.value]) === null || _selectedUpsellProduc === void 0 ? void 0 : _selectedUpsellProduc.length) === type.maxSelections;
  });
  var onUpsellProductAdd = function onUpsellProductAdd(product) {
    var _selectedUpsellProduc2;
    if (product.productType === _constants.PRODUCT_TYPES.INSURANCE && !((_selectedUpsellProduc2 = selectedUpsellProducts.accessory) !== null && _selectedUpsellProduc2 !== void 0 && _selectedUpsellProduc2.length) && connectivityPlan.selected) {
      dispatch((0, _upsellActions.setIsConnectivityPlanSelected)(false));
    }
    dispatch((0, _upsellActions.addSelectedUpsellProduct)(product.id, product.category[0].id));
  };
  var onUpsellProductRemove = function onUpsellProductRemove(product) {
    if (product.productType === _constants.PRODUCT_TYPES.ACCESSORY && connectivityPlan.selected) {
      dispatch((0, _upsellActions.setIsConnectivityPlanSelected)(false));
    }
    dispatch((0, _upsellActions.removeSelectedUpsellProduct)(product.id, product.category[0].id));
  };
  var setConnectivityPlanIsSelected = function setConnectivityPlanIsSelected(selected) {
    dispatch((0, _upsellActions.setIsConnectivityPlanSelected)(selected));
  };
  var relationshipOfferingGroups = Object.values((0, _lodash.default)(offerings, function (offering) {
    return offering.category[0].id;
  })).map(function (group) {
    return {
      products: group,
      selectedProducts: selectedUpsellProducts[group[0].category[0].id],
      groupName: group[0].category[0].id
    };
  });
  var isDisabled = function isDisabled(groupName, productId) {
    return categoryStatus[groupName] && !selectedUpsellProducts[groupName].includes(productId);
  };
  return {
    relationshipOfferingGroups: relationshipOfferingGroups,
    isDisabled: isDisabled,
    onUpsellProductAdd: onUpsellProductAdd,
    onUpsellProductRemove: onUpsellProductRemove,
    offerings: offerings,
    connectivityPlan: connectivityPlan,
    setConnectivityPlanIsSelected: setConnectivityPlanIsSelected
  };
};
var _default = useUpsell;
exports.default = _default;